// @flow weak

import { connect } from 'react-redux';

import Link from 'app/common/components/Link';
import TrackActions from 'app/track/TrackActions';

const mapDispatchToProps = dispatch => {
  return {
    onTrack(message, data) {
      dispatch(TrackActions.track(message, data));
    },
  };
};

const LinkContainer = connect(null, mapDispatchToProps)(Link);

export default LinkContainer;
